import { lazy, Suspense, type ComponentProps } from 'react';
import { Skeleton } from '@xiltrion/ui/skeleton';

/**
 * Editor de texto con formato (Tiptap) y su vista de lectura. Se cargan aparte, solo cuando una pantalla los usa, para
 * no sumar el editor al JavaScript inicial de la aplicación. La implementación está en `RichTextEditorImpl.tsx`.
 */
export type { RichTextHandle } from './RichTextEditorImpl';

const Editor = lazy(() => import('./RichTextEditorImpl').then((m) => ({ default: m.RichTextEditor })));
const View = lazy(() => import('./RichTextEditorImpl').then((m) => ({ default: m.RichTextView })));

export function RichTextEditor(props: ComponentProps<typeof Editor>) {
  return <Suspense fallback={<Skeleton className="w-full rounded-md" style={{ height: (props.minHeight ?? 240) + 40 }} />}><Editor {...props} /></Suspense>;
}

export function RichTextView(props: ComponentProps<typeof View>) {
  return <Suspense fallback={<Skeleton className="h-24 w-full rounded" />}><View {...props} /></Suspense>;
}
